module.exports = __webpack_public_path__ + "static/media/recruitbannerbg@2x.f52bcfbf.png";